import { ADD_MESSAGE, REMOVE_MESSAGE, CLEAR_MESSAGES } from '../redux-action-types'

const initialState = {
  items: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD_MESSAGE:
      return {
        ...state,
        items: [...state.items, action.message]
      }
    case REMOVE_MESSAGE:
      return {
        ...state,
        items: state.items.filter(m => m.id !== action.id)
      }
    case CLEAR_MESSAGES:
      return {
        ...state,
        items: []
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/messages-reducer.js